module.exports = __webpack_public_path__ + "static/media/3-march-web.2884fc8f.png";